module.exports = __webpack_public_path__ + "img/pink-arrow.960b5930.svg";